import { Expense, Vendor, VendorTypeEnum } from "@finway-group/shared/lib/models"
import { Button, Tooltip } from "antd"
import React from "react"
import { RotateCcw } from "react-feather"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { CreditorDataList } from "~Components/CreditorDataList"
import { patchExpense, syncExpense } from "~Shared/store/actions/expense/expenseActions"
import { ExpenseHttpService, NotificationService } from "../../../../../shared/services"
import { isExpenseCreditorOutdated } from "../../../../../shared/utils/expense.utils"
import { UserCreditor } from "../../../../../shared/utils/vendor.utils"

interface VendorTabProps {
    expense: Expense
    isExpenseUpdating: boolean
    expenseCreditor: Vendor | UserCreditor
    setIsExpenseUpdating?: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedExpense?: (expense: Expense | undefined) => void
}

export const VendorTabContent = ({ expense, expenseCreditor, isExpenseUpdating, setIsExpenseUpdating, setSelectedExpense }: VendorTabProps) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const onExpenseVendorDataUpdate = async (patchVendorData: Partial<Pick<Vendor, "iban" | "bic">>) => {
        try {
            setIsExpenseUpdating?.(true)
            const patchPayload = {
                vendor: {
                    _id: expense.vendor?._id,
                    ...patchVendorData,
                },
                vendorType: VendorTypeEnum.VENDOR,
            }

            const updatedExpenseResponse = await patchExpense(expense.id, patchPayload)(dispatch)
            setSelectedExpense?.(updatedExpenseResponse)
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:error"))
        } finally {
            setIsExpenseUpdating?.(false)
        }
    }

    const onSyncExpenseWithCreditor = async () => {
        try {
            await ExpenseHttpService.syncExpenseCreditor(expense.id)
            dispatch(syncExpense(expense.id))
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:error"))
        }
    }

    return (
        <>
            {isExpenseCreditorOutdated({
                vendorType: expense.vendorType,
                vendor: expenseCreditor,
                vendorReference: expense.getCreditor()?.source,
            }) &&
                !expense.gobdInvoiceComplianceDate && (
                    <Tooltip title={t("label:vendor_data_changed")}>
                        <Button className="w-full mt-5 mb-10 flex-1 btn-default p-5" onClick={onSyncExpenseWithCreditor}>
                            <RotateCcw />
                            <span>{t("action:request.sync")}</span>
                        </Button>
                    </Tooltip>
                )}
            <CreditorDataList
                documentCreditor={expenseCreditor}
                document={expense}
                isUpdating={isExpenseUpdating}
                canEditItems={true}
                onVendorDataUpdate={onExpenseVendorDataUpdate}
            />
        </>
    )
}
